import "./index.css";

import React from "react";
import { BrowserRouter, Routes as ReactRoutes, Route } from "react-router-dom";

import App from "./App";
import { ApplicationView } from "./components/views/ApplicationView";
import { BankReaderCallbackTinkView } from "./components/views/BankReaderCallbackTinkView";
import { BankReaderCallbackView } from "./components/views/BankReaderCallbackView/BankReaderCallbackView";
import { CallbackView } from "./components/views/CallbackView";
import { ContractView } from "./components/views/ContractView";
import { FlywireCallbackView } from "./components/views/FlywireCallbackView/FlywireCallbackView";
import { NotFoundView } from "./components/views/NotFoundView";
import { PaymentView } from "./components/views/PaymentView/PaymentView";
import { TestApplicationView } from "./components/views/TestApplicationView";

export const paths = {
  Application: "/application",
  TestApplication: "/testapplication",
  PaymentView: "/payment",
  BankReaderCallback: "/bankreader-callback",
  VideoId: "/video-id",
  Contract: "/contract",
  CallbackTink: "/tink/callback",
  CallbackFlywire: "/payment/flywire",
  Callback: "/callback",
  NotFoundView: "/",
};

export default function Routes() {
  return (
    <BrowserRouter>
      <ReactRoutes>
        <Route
          path={paths.Application}
          element={<App currentPath={location.pathname} />}
        >
          <Route path={":loanId/*"} element={<ApplicationView />} />
        </Route>
        <Route
          path={paths.TestApplication}
          element={<App currentPath={location.pathname} />}
        >
          <Route path={":loanId/*"} element={<TestApplicationView />} />
        </Route>
        <Route
          path={paths.VideoId}
          element={<App currentPath={location.pathname} />}
        >
          <Route path={":loanId/*"} element={<ApplicationView />} />
        </Route>
        <Route
          path={paths.Contract}
          element={<App currentPath={location.pathname} />}
        >
          <Route path={":loanId/*"} element={<ContractView />} />
        </Route>
        <Route
          path={paths.PaymentView}
          element={<App currentPath={location.pathname} />}
        >
          <Route path={":paymentPlanLineId/*"} element={<PaymentView />} />
        </Route>
        <Route
          path={paths.CallbackFlywire}
          element={<App currentPath={location.pathname} />}
        >
          <Route
            path={":paymentPlanLineId/*"}
            element={<FlywireCallbackView />}
          />
        </Route>
        <Route
          path={paths.BankReaderCallback}
          element={<App currentPath={location.pathname} />}
        >
          <Route path={":status"} element={<BankReaderCallbackView />} />
        </Route>
        <Route
          path={paths.CallbackTink}
          element={<BankReaderCallbackTinkView />}
        />
        <Route path={paths.Callback} element={<CallbackView />} />
        <Route path={"*"} element={<App currentPath={location.pathname} />}>
          <Route path={"*"} element={<NotFoundView />} />
        </Route>
      </ReactRoutes>
    </BrowserRouter>
  );
}
